import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '@/store'

// 1. 创建路由组件，一个页面就是一个组件
import Main from '../views/Main.vue'
import Home from '../views/Home.vue'
import User from '../views/User.vue'
import Belt from '../views/Belt.vue'
import Camera from '../views/Camera.vue'
import Product from '../views/Product.vue'
import Login from '../views/Login.vue'
import UserInfo from '../views/UserInfo.vue'
import BeltInfo from '../views/BeltInfo.vue'
import BeltUpFW from '../views/BeltUpFW.vue'
import FeederFirmware from '../views/FeederFirmware.vue'
import FeederUpFW from '../views/FeederUpFW.vue'
import BeltBootFirmware from '@/views/BeltBootFirmware.vue'
import BeltAppFirmware from '@/views/BeltAppFirmware.vue'
import AppFWUpgrade from '@/views/AppFWUpgrade.vue'
import HWUpgrade from '@/views/HWUpgrade.vue'
import BootFWUpgrade from '@/views/BootFWUpgrade.vue'
import SimCards from '@/views/SimCards.vue'
import Devices from '../views/Devices.vue'
// import { component } from 'vue/types/umd'

// 2. 将路由与组件进行映射
const routes = [
    // 主路由
    { 
        path: '/',
        component: Main,
        redirect: '/login', // 重定向
        children: [     // 路由嵌套，子路由
            { path: 'home', name: 'home', component: Home },
            { path: 'user', component: User },
            { path: 'belt', component: Belt },
            { path: 'camera', component: Camera },
            { path: 'product', component: Product },
            { path: 'userinfo', component: UserInfo },
            { path: 'beltinfo', component: BeltInfo },
            { path: 'beltupfw', component: BeltUpFW},
            { path: 'feederfirmware', component: FeederFirmware },
            { path: 'feederupfw', component: FeederUpFW},
            { path: 'beltbootfirmware', component: BeltBootFirmware},
            { path: 'beltappfirmware', component: BeltAppFirmware},
            { path: 'boot_fw_upgrade', component: BootFWUpgrade },
            { path: 'app_fw_upgrade', component: AppFWUpgrade },
            { path: 'hw_upgrade', component: HWUpgrade },
            { path: 'simCards', component: SimCards},
            { path: 'devices', component: Devices}
        ]
    },
    {
        path: '/login',
        name: 'login',
        component: Login
    }
]

// 3. 创建 router实例
const router = new VueRouter({
    routes
});
export default router

// 4. 将router挂载到根节点上
//    在main.js 的Vue 对象上加入 router

// 5. 在html中加入路由出口，也就是在APP.vue里加入<router-view/>标签

Vue.use(VueRouter);